import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'

import {
    Anton,
    Cormorant_Garamond,
    DM_Serif_Display,
    Fredoka,
    Instrument_Serif,
    Inter,
    Yellowtail
} from 'next/font/google'

const sans = Inter({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const script = Yellowtail({
    subsets: ['latin'],
    weight: '400'
})

const serif = Cormorant_Garamond({
    subsets: ['latin'],
    weight: ['400', '500'],
    style: ['normal', 'italic']
})

/* The four print faces are only drawn onto garment canvases, so they are not preloaded; the storefront requests them as soon as it mounts. */
const printSerif = Instrument_Serif({
    subsets: ['latin'],
    preload: false,
    weight: '400',
    style: ['normal', 'italic']
})

const printDisplay = DM_Serif_Display({
    subsets: ['latin'],
    preload: false,
    weight: '400'
})

const printCondensed = Anton({
    subsets: ['latin'],
    preload: false,
    weight: '400'
})

const printRound = Fredoka({
    subsets: ['latin'],
    preload: false,
    weight: ['600', '700']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-heading:${script.style.fontFamily};--font-app-serif:${serif.style.fontFamily};--font-print-serif:${printSerif.style.fontFamily};--font-print-display:${printDisplay.style.fontFamily};--font-print-round:${printRound.style.fontFamily};--font-print-condensed:${printCondensed.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' key='viewport' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
